import React, { useEffect } from "react"; 
import { Link } from 'react-router-dom';
import axios from 'axios'; 
// @mui/material
import { useTheme } from "@mui/material/styles";
import {Box, Tooltip, Fab, CardContent, Container, Typography} from "@mui/material";
// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components//Card/CardBody";
import { baseUrl } from '../../components//shared/baseUrl';
import { mongoUrl } from '../../components//shared/mongoUrl';
import {useSelector} from 'react-redux';
import Skeleton from "@mui/material/Skeleton"
import styles from "../../components/assets/jss/material-dashboard-react/views/dashboardStyle.js";


const datepartial = (date) =>{
            
  var st = new Date(date).toString();
  return(
      st.substring(0, 15)
  );
}

var cla = [{
  "_id":"6006f33eef2c0d65ccbf6601",
    "title": "Class IX",
    "teacherId":"5fe192d970d8c633c005da24",
    "sessionActive":false,
    "image":"assets/images/cimage.jpg",
    "std":"IX"
}]


function RenderClassItem({ clas }){


  return(
        <Link to={`/student/dashboard/viewsession/${clas._id}`}>
          <Card style={{backgroundColor:'#fffab4'}}>
            <CardContent>
              {clas.image.substring(0,6)!=='assets'?
              <img alt={`${clas.title}`} className="card-img-top" src={mongoUrl+clas.image} />
              :<img alt={`${clas.title}`} className="card-img-top" src={baseUrl+clas.image} />}
            </CardContent>
            <CardBody>
              <h4 sx={styles.cardTitle}>{clas.title}</h4>
              <p sx={styles.cardCategory}>
                Created: {datepartial(clas.Created)}  
                | Active: true
              </p>
            </CardBody>
            
          </Card>
           </Link>
        );

}

export default function StudentDashboard() {
  const [classe, setclasse] = React.useState([]);
  const [profile, setprofile] = React.useState('');
  const [loading, setloading] = React.useState(true);
  const user = useSelector(state => state.user)
  

useEffect(() => {

  if (!user || !user.token) {
    console.warn("User not loaded yet");
    return;
  }  
  
  
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const loadData=()=>{
      const config = {
        headers: { Authorization: `Bearer ${user.token}` }
    };
    console.log(user.token)
          
      setclasse(cla)  ////Code to set class when only  one class is created

      axios.get(`${baseUrl}pyinterpreter/profile/email/${user.email}`)
      .then((response) => {
        
        console.log('got email profile')
        console.log(response.data)
        setprofile(response.data)
        setloading(false)

      })
      .catch((error)=>{
        console.log(error);
        });
  };
    loadData();

    return() => {source.cancel();
    };
}, [user]);

console.log(classe)

  const menu=classe.map((clas) => {
    return (
          <GridItem xs={12} sm={9} md={3} key={clas._id}>
                <RenderClassItem clas={clas} />
          </GridItem>
    );
})


  return (
    loading!==true?
      <div>  
        <Container maxWidth="xl" sx={{ py: 5 }}>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h3" gutterBottom>
              My Classes
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Active classes
            </Typography>
          </Box>
        </Container>
     
        {loading===false? 
        <GridContainer>
          {classe.length === 0?<p>No Classes added by anyone. Contact your teacher</p>:null}
          {menu} 
        </GridContainer>:<p>This is some problem / Please Login again</p> }

      <Container maxWidth="xl" sx={{ py: 5 }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="subtitle1" color="text.secondary">
            Inactive classes
          </Typography>
        </Box>
      </Container>


    </div>:<GridContainer spacing={3}>
        <GridItem xs={12} sm={12} md={4}>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Skeleton variant="text" /> 
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5, padding: 2 }}>
            <Skeleton animation="wave" variant="rectangular" width={420} height={300} />    
          </Box>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5 }}>
            <Skeleton animation="wave" variant="rectangular" width={420} height={300} />    
          </Box> 
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5 }}>
            <Skeleton variant="circular" width={420} height={300} />    
          </Box> 
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Skeleton variant="text" /> 
        </GridItem>  
      </GridContainer>
  );
}
